const r = "backgroundWrapper_tArEY", a = "backdrop_ZVzFc", c = {
  backgroundWrapper: r,
  backdrop: a
};
export {
  a as backdrop,
  r as backgroundWrapper,
  c as default
};
//# sourceMappingURL=background.module.scss.js.map
